export default __webpack_public_path__ + "static/media/AvatarKids-09.cdeedbce.png";